import { apiRequest } from "./apiClient";

export const notifyUser = (email: string) => {
  return apiRequest("/notify", {
    method: "POST",
    body: { email },
  });
};